export const TRANSLATIONS_PT = {
    // COMMON MESSAGES
    UNAUTHORIZED: "Não autorizado",
    ERROR_NO_PERMISSION: "Você não tem permissão",
    NOT_FOUND: "Serviço não encontrado",
    BAD_REQUEST: "Pedido ruim",
    SERVICE_ERROR: "Erro de serviço",
    NETWORK_ERROR: "Você está tendo problemas com sua conexão com a Internet, verifique e tente novamente",
    MAINTENANCE_MODE:
        "Desculpe, estamos fazendo uma melhoria no sistema, incorporamos novos recursos e algumas atualizações de segurança, nos dê mais alguns minutos para terminar. Em breve você poderá apreciá-los.",
    ERROR_INVALID_VERIFICATION_CODE: "Código de verificação inválido",
    ERROR_CODE_EXPIRED: "O código de verificação expirou",
    ERROR_CONTACT_NOT_FOUND: "Contato não encontrado",
    ERROR_GEOLOCATION_UNKNOWN: "Ocorreu um erro desconhecido ao tentar acessar sua localização.",
    ERROR_GEOLOCATION_PERMISSION_DENIED: "Você negou o acesso à sua localização. Por favor, permita o acesso para continuar.",
    ERROR_GEOLOCATION_POSITION_UNAVAILABLE: "Sua localização não está disponível. Por favor, verifique as configurações do seu dispositivo.",
    ERROR_GEOLOCATION_TIMEOUT: "A solicitação para acessar sua localização expirou. Por favor, tente novamente.",

    fieldRequired: "Este campo é obrigatório",
    fieldInvalid: "Valor inválido",

    SUCCESS_DOCUMENT_SHARED: "Documento compartilhado com sucesso",

    CONFIRM_CLOSE_TICKET: "Você tem certeza de que deseja fechar este ticket? Esta ação não pode ser desfeita.",
    CONFIRM_RESOLVE_TICKET: "Você tem certeza de que deseja resolver este ticket? Esta ação não pode ser desfeita.",

    // LAYOUT
    footer1: "legale.io é uma empresa Despapeliza Llc. 7345 W Sand Lake RD STE 210, OFC 6837, Orlando, FL, USA",
    footer2: "Todos os direitos reservados legale",
    treesSaved: "Árvores foram salvas usando Legale",
    signout: "Sair",

    // LOGIN
    emailVerify: "Verificação de e-mail",
    email: "E-mail",
    submit: "Enviar",
    sendCode: "Enviar código",
    iHaveCode: "Eu tenho código",
    verificationCode: "Código de verificação",
    enterCode: "Coloque o código",
    verify: "Verificar",
    resendCode: "Reenviar código",

    // EXPLORER
    drive: "Drive",
    myDocuments: "Meus documentos",
    sharedDocuments: "Documentos compartilhados",
    searchResult: "Resultado da pesquisa",
    paginationDescription: "De {{fromNumber}} a {{toNumber}} (Total {{totalNumber}})",
    loadMore: "Carregue mais",
    user: "Usuário",
    document: "Documento",
    description: "Descrição",
    date: "Encontro",
    noData: "Sem dados",
    attachedFile: "Arquivo anexo",
    file: "Arquivo",
    view: "Visualizar",
    download: "Download",
    filePreviewNotSupport: "A visualização do arquivo `{{fileName}}` não é suportada, faça download para visualizá-lo.",
    share: "Compartilhar",
    verification: "Verificação",
    workflowInformation: "Informações sobre Workflow",
    flux: "Fluxo",
    flux_priority: "Por prioridade",
    flux_simultaneously: "Simultaneamente",
    method: "Método",
    rejectedByUser: "O documento foi rejeitado por este usuário",
    startedAt: "Começou em",
    openedAt: "Aberto em",
    approvedAt: "Aprovado em",
    signedAt: "Assinado em",
    rejectedAt: "Rejeitado em",
    pausedAt: "Pausado em",
    signLink: "URL de assinatura",
    signStatus: "Aprovar / Assinar status",
    signMethod: "Método de Sinalização",
    signFlowStatus0: "NOT SIGNED",
    signFlowStatus1: "EM ANDAMENTO",
    signFlowStatus2: "ASSINADO",
    signFlowStatus3: "REJEITADO",
    signFlowStatus4: "PAUSADO",
    signFlowStatus5: "EM ANDAMENTO",
    signFlowStatus100: "APROVADO",
    copied: "Copiado",
    signing: "Assinatura",
    productName_document: "Documento",
    productName_subscription: "Inscrição",
    productName_no_sms: "Controlo remoto",
    productName_certification: "Certificado de nuvem",
    productName_sms: "SMS remoto",
    productName_fea: "Assinatura avançada remota",
    productName_bulk_sign: "Sinal de massa",
    productName_video_validation: "Verificação de vídeo",
    productName_selfie_validation: "Verificação de selfie",
    productName_id_validation: "Anexando ID",
    productName_geolocation: "Geolocalização",
    productName_secondary_user: "Usuários",
    productName_storage: "Armazenar",
    productName_approve: "Aprovar por e-mail",
    productName_approve_legale: "Aprovado por usuário Legale",
    productName_approve_api: "Aprovar",
    productName_email_pin: "PIN do email",
    productName_fiema_sobre: "Sinal de grupo",
    productName_tablet_device: "Dispositivo Legale móvel",
    productName_tablet_sign: "Assinatura Legale móvel",
    productName_signbox: "Signbox",
    productName_local_certificate: "Certificado local",
    productName_stamp: "Stamp",
    productName_no_certification: "Definir pelo signatário",
    productName_signing_portal: "Portal de assinatura",
    productName_send_email: "Enviar e-mail",
    sign: "Assinar",
    signStatusNotSigned: "Não assinado",
    signStatusSigned: "Assinado",
    signStatusRejected: "Rejeitado",
    signStatusReadyToSign: "Pronto para assinar",
    signStatusWaitingForReview: "Aguardando análise",
    inProcess: "Em processo",
    finished: "Concluído",
    failed: "Falhou",
    stopped: "Parou",
    search: "Procurar",
    startDate: "Data de início",
    endDate: "Data final",
    all: "Tudo",
    clear: "Claro",
    shareDocument: "Compartilhar documento",
    emails: "E-mails",
    remove: "Remover",

    upload: "carregar",
    draw: "Empate",
    input: "Entrada",
    chooseSignMethod: "Escolha o método de sinalização",
    signatureImageDrawingTip: "Não desenhe sua assinatura sobre o código QR",
    signatureImageDescription1: "Desenhe a imagem da sua assinatura sobre a caixa",
    signatureImageDescription2:
        "Ao assinar este documento com uma assinatura eletrônica, você concorda que esta assinatura será tão válida quanto uma assinatura manuscrita de acordo com as leis locais",
    signText: "Texto de assinatura",
    clearSignature: "Assinatura clara",
    signatureImage: "Imagem de assinatura",
    drawSignature: "Desenhar assinatura",
    fullName: "Nome completo",
    uploadSignature: "Assinatura de upload",
    deleteSignature: "Excluir assinatura",
    localCertification: "Certificado local",
    usbToken: "Token USB",
    usbTokenDescription1: "Use um token de assinatura avançado por porta USB",
    usbTokenDescription2: "Para fazer isso, você deve baixar o plugin clicando no botão de download",
    usbTokenDescription3: "Nota: Compatível apenas com o sistema operacional Windows 10",
    geoLocation: "Geolocalização",
    geolocationDescription:
        "<span>A geolocalização é usada para cumprir requisitos legais e regulamentares. Em certos casos, regulamentos ou leis podem exigir a coleta de informações de localização. Por exemplo, no caso de serviços financeiros, pode ser necessário coletar informações de geolocalização para cumprir os regulamentos de combate à lavagem de dinheiro ou para evitar fraudes. A verificação da localização geográfica ajuda a garantir que as transações ou eventos ocorram dentro dos limites do mesmo país ou estado, conforme exigido pelos regulamentos relevantes.</span><br><br><span>Observação: o banco de dados usado para geolocalização de IP pode conter erros ou estar desatualizado. Isso pode resultar em informações incorretas ou locais incorretos associados a um determinado endereço IP.</span>",
    useGeoLocation: "Ativar geolocalização",
    geolocationCheckboxDescription:
        "Aceito a <a href='https://legale.io/docs/use-and-processing-of-geolocation-data-in-legale-io/' target='_blank'>política de privacidade</a> e autorizo o uso da minha localização para determinar a jurisdição notarial correspondente.",
    noNumberToUseGeolocation:
        "Você não tem valor para usar a Geolocalização, compre primeiro na loja ou entre em contato com seu executivo.",
    SUCCESS_DOCUMENTS_SIGNED: "Documentos selecionados assinados com sucesso.",
    FAIL_DOCUMENTS_SIGNED: "Falha ao assinar documentos selecionados.",
    SUCCESS_BULK_SIGN: "Todos os {{successCount}} documentos selecionados foram assinados com sucesso.",
    INFO_BULK_SIGN: "Foram assinados {{successCount}} de {{totalCount}} documentos selecionados com sucesso.",
    ERROR_BULK_SIGN: "Falha ao assinar documentos selecionados.",
    geolocationNotAuthorized: "A geolocalização é requerida, você precisa autorizar o uso da localização.",
    SIGN_METHODS_INVALID: "Não é possível assinar vários documentos usando assinaturas avançadas. Por favor, selecione um único documento e tente novamente.",
    SUCCESS_SIGN_TRIGGER: "A assinatura da thread foi iniciada com sucesso.",
    WARNING_FEA_BULK_SIGN: "Não é possível assinar vários documentos usando assinaturas avançadas.",
    // DOCUMENT
    documentPreview: "Visualização do documento",
    pdfPaginationDescription: "Página {{pageNumber}} de {{totalPage}}",

    // TICKET
    request: "Solicitação",
    tickets: "Tickets",
    myTickets: "Meus bilhetes",
    createTicket: "Criar ticket",
    subject: "Assunto",
    create: "Criar",
    ticket: "Ticket",
    chat: "Bate-papo",
    viewHistory: "Ver histórico",
    open: "Aberto",
    inProgress: "Em progresso",
    resolved: "Resolvido",
    closed: "Fechado",
    low: "Low",
    medium: "Médio",
    high: "Alto",
    urgent: "Urgente",
    status: "Estado",
    priority: "Prioridade",
    edit: "Editar",
    closeTicket: "Fechar ticket",
    resolveTicket: "Resolver ticket",
    cancel: "Cancelar",
    save: "Salvar",
    resolve: "Resolver",
    close: "Fechar",
    noTicketCreated: "Nenhum ticket criado",
    selectFileDescription:
        '<span>Você pode arrastar arquivos como {{fileTypes}} para fazer o upload para legale <br> ou <span class="color-blue">clique para selecioná-los</span></span>',
    category: "Categoria",
    subCategory: "Subcategoria",
    editTemplate: "Editar modelo",
    templateContent: "Conteúdo do modelo",
    name: "Nome",
    callbackUrl: "URL de callback",
    content: "Conteúdo",
    formFields: "Campos do formulário",
    noFormFields: "Sem campos do formulário",
    unnamedField: "Campo sem nome",
    portrait: "Retrato",
    landscape: "Paisagem",
    preview: "Pré-visualização",
    smartTemplateSaved: "Modelo inteligente salvo com sucesso",
    unsavedChangesTitle: "Você tem alterações não salvas",
    unsavedChangesDescription:
        "Se você sair desta página agora, suas alterações serão perdidas.\nDeseja salvar seu documento antes de sair?",
    discardChanges: "Descartar alterações",
    stayOnPage: "Ficar na página",
    saveAndLeave: "Salvar e sair",
    ERROR_SMART_TEMPLATE_FIELDS_REQUIRED: "Preencha todos os campos obrigatórios",
    home: "Início",
    versionControl: "Controle de versão",
    previewForm: "Pré-visualizar formulário",
    importFromDocx: "Importar do DOCX",
    ai: "IA",
    addField: "Adicionar campo",
    copyFieldNumber: "Copiar número do campo",
    copyIntoYourTemplate: "Copiar para o seu modelo",
    fieldConfiguration: "Configuração do campo",
    moveFieldUp: "Mover campo para cima",
    moveFieldDown: "Mover campo para baixo",
    addFile: "Adicionar arquivo",
    fileConfiguration: "Configuração do arquivo",
    moveFileUp: "Mover arquivo para cima",
    moveFileDown: "Mover arquivo para baixo",
    attachedFiles: "Arquivos anexados",
    watermark: "Marca d'água",
    opacity: "Opacidade",
    rotation: "Rotação",
    noAttachedFiles: "Nenhum arquivo anexado",
    previewFormHelp: "Esta é uma pré-visualização dos campos do formulário.",
    type: "Tipo",
    hidden: "Oculto",
    text: "Texto",
    fieldType_select: "Seleção",
    number: "Número",
    time: "Hora",
    paragraph: "Parágrafo",
    phone: "Telefone",
    link: "Link",
    image: "Imagem",
    title: "Título",
    imagePreview: "Pré-visualização de imagem",
    fileLengthError: "O comprimento máximo é de {{limit}} caracteres",
    yesNo: "Sim/Não",
    currentDate: "Data atual",
    conditionalWord: "Palavra condicional",
    conditionalParagraph: "Parágrafo condicional",
    multipleConditionalParagraph: "Parágrafo condicional múltiplo",
    takePhoto: "Tirar foto",
    conditionalImage: "Imagem condicional",
    answerSelection: "Seleção de resposta",
    answerSummary: "Resumo de respostas",
    GUID: "GUID",
    userName: "Nome do usuário",
    origin: "Origem",
    idNumber: "Número de ID",
    Folio: "Folio",
    documentCompliance: "Conformidade documental",
    itemGroup: "Grupo de itens",
    isMultipleSelection: "Seleção múltipla",
    conditionalVisible: "Visível condicionalmente",
    noFormat: "Sem formato",
    numberInWords: "número por extenso",
    NumberInWords: "Número por extenso",
    attachedToDocument: "Anexar ao documento",
    createNewFile: "Criar novo arquivo",
    warningSelectWithoutItem: "Adicione pelo menos um item selecionável",
    inputSelectableItem: "Item selecionável",
    add: "Adicionar",
    groups: "Grupos",
    groupName: "Nome do grupo",
    documentType: "Tipo de documento",
    warningWithoutDocumentTypes: "Adicione pelo menos um tipo de documento",
    warningWithoutGroups: "Adicione pelo menos um grupo",
    history: "História",
    comments: "Comentários",
    draft: "Rascunho",
    restoreThisVersion: "Restaurar esta versão",
    noComments: "Sem comentários",
    addComment: "Adicionar comentário",
    selectTextToComment: "Selecione o texto no editor e adicione um comentário",
    SUCCESS_VERSION_RESTORED: "Versão restaurada com sucesso",
    edited: "editado",
    reply: "Responder",
    justNow: "agora",
    minAgo: "há {{count}} min",
    minsAgo: "há {{count}} mins",
    hourAgo: "há {{count}} hora",
    hoursAgo: "há {{count}} horas",
    dayAgo: "há {{count}} dia",
    daysAgo: "há {{count}} dias",
    CONFIRM_DELETE: "Você tem certeza que quer deletar?",
    review: "Revisão",
    delete: "Excluir",
    lastUpdate: "Última atualização",
    no: "No",
    ticketDetail: "Detalhe do bilhete",
    backToTickets: "Voltar aos bilhetes",
    userInformation: "Informações do usuário",
    contactInformation: "Informações de contato",
    noMessages: "Nenhuma mensagem ainda. Inicie a conversa!",
    ok: "OK",
    firstName: "Nome",
    lastName1: "Sobrenome 1",
    lastName2: "Sobrenome 2",
    typeMessage: "Digite uma mensagem...",

    // MISC
    insert: "Inserir",
    format: "Formatar",
    note: "Observação",
    selectFile: "Selecione o arquivo",
    selectUser: "Selecione o usuário",

    // SMART TEMPLATE REVIEWS
    reviews: "Revisões",
    accept: "Aceitar",
    reject: "Rejeitar",
    feedback: "Comentários",
    revert: "Reverter",
    acceptAll: "Aceitar tudo",
    rejectAll: "Rejeitar tudo",
    complete: "Completo",
    noSuggestions: "Sem edições sugeridas",
    addFeedback: "Adicionar feedback",
    addedParagraph: "Parágrafo adicionado",
    removedParagraph: "Parágrafo removido",
    modifiedText: "Texto modificado",
    replacedTextWithText: "Texto substituído com texto",
};
